import * as fromDatatype from '../datatype-library/index';

export interface Bl_inv_stock_reservation_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  amount_cogs: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.IntegerDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  coupon_line_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  mrp_prodsys_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  description:fromDatatype.VarcharDatatypeInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface; 
  total_reserve_qty: fromDatatype.NumericDatatypeInterface;
  crm_contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  crm_contact_key_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
}

export class Bl_inv_stock_reservation_hdr_RowClass implements Bl_inv_stock_reservation_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  amount_cogs: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.IntegerDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  coupon_line_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  mrp_prodsys_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  description:fromDatatype.VarcharDatatypeInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface; 
  total_reserve_qty: fromDatatype.NumericDatatypeInterface;
  crm_contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  crm_contact_key_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
}
